import React, { useEffect, useState, Fragment } from 'react'
import firebase from '../firebase'
import { useGlobalState } from "../useGlobalState"
import {
    Paper,
    Button,
    Avatar,
    Typography,
    TextField,
    Tooltip,
    FormControl,
    FormHelperText,
    IconButton,
    Select,
    OutlinedInput,
} from '@material-ui/core'
import { Prompt } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'
import imageCompression from 'browser-image-compression'
import {ReactComponent as LoadingDots} from './threeDots.svg'
import BusinessIcon from '@material-ui/icons/Business'
import PhotoCamera from '@material-ui/icons/PhotoCamera'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle'
import { red } from '@material-ui/core/colors'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block',
        margin: theme.spacing(1),
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'top center',
		[theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
			backgroundPosition: 'center center',
		},
    },
    mainmobile: {
        width: 'auto',
        display: 'block',
        margin: theme.spacing(1),
    },
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(2)}px`,
        [theme.breakpoints.up(620 + theme.spacing(3) * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
		},
    },
    paperList: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textDecoration: 'none',
        padding: `${theme.spacing(2)}px ${theme.spacing(2)}px ${theme.spacing(2)}px`,
        [theme.breakpoints.up(620 + theme.spacing(3) * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
		},
    },
    submit: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    input: {
        fontSize: 48,
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
    },
    logo: {
        width: 120,
    },
    bgimg: {
        width: '100%',
    },
    formHelper: {
        textAlign: 'center',
        marginTop: -5,
    },
    formControl: {
        margin: theme.spacing(0),
        minWidth: 100,
        [theme.breakpoints.down(360)]: {
            minWidth: 98,
            width: 100,
        },
    },
    customAlert: {
        width: '95%',
        marginLeft: 'auto',
        marginRight: 'auto',
        alignItems: 'center',
        textAlign: 'center',
        backgroundColor: theme.palette.background.paper,
        borderRadius: 3,
        boxShadow: theme.shadows[5],
        padding: `${theme.spacing(1)}px ${theme.spacing(3)}px ${theme.spacing(2)}px`,
        [theme.breakpoints.up(480 + theme.spacing(3) * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    alertButton: {
        margin: theme.spacing(1),
        fontWeight: 500,
        borderWidth: 2,
        '&:hover': {
            borderWidth: 2,
        },
    },
})

const Settings = function Settings(props) {
    const { classes } = props
    const { t, i18n } = useTranslation()
    const [isadmin, setIsadmin] = useState(false)
    const [inputChanged, setinputChanged] = useState()
    const [logo, setLogo] = useState('')
    const [logochange, setLogochange] = useState(false)
    const [bgimage, setBgimage] = useState('')
    const [bgimagechange, setBgimagechange] = useState(false)
    const [apptitle, setApptitle] = useState('')
    const [loading, setLoading] = useState(false)
    const [bgloading, setBgloading] = useState(false)
    const [switchchange, setSwitchchange] = useState('')
    const [state, setState] = useState({
        lang: localStorage.getItem('language'),
        name: 'en',
    })
    // eslint-disable-next-line
    const [{ }, dispatch] = useGlobalState()

    useEffect(() => {
        document.title = window.localStorage.getItem('apptitle') + ` - ${t('settings.label')}`
    }, [t])

    useEffect(() => {
        if (firebase.getCurrentUsername()) {
            return
        } else {
            alert(t('loginfirst.label'))
            window.location.href = '/login'
            return null
        }
    }, [t])

    useEffect(() => {
        if (firebase.getCurrentUsername()) {
            firebase.checkClaims().then((idTokenResult) => {
                if (!!idTokenResult.claims.admin) {
                    setIsadmin(true)
                } else {
                    setIsadmin(false)
                }
            })
        }
    }, [])

    useEffect(() => {
        firebase.db.collection('backupsettings').doc('settings').get()
            .then((doc) => {
                if (doc.exists) {
                    dispatch({
                        type: 'changeLogo',
                        newTheme: { logosrc: doc.data().logo }
                    })
                    setLogo(doc.data().logo)
                    dispatch({
                        type: 'changeBgimage',
                        newTheme: { bgimagesrc: doc.data().bgimage }
                    })
                    setBgimage(doc.data().bgimage)
                    setApptitle(doc.data().apptitle)
                    localStorage.setItem('language', doc.data().language)
                } else {
                    setLogo('')
                    setBgimage('')
                    setApptitle('')
                    localStorage.setItem('language', 'en')
                }
            })
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        firebase.db.collection('backupsettings').doc('settings').get()
            .then((doc) => {
                if (doc.exists) {
                    setLogo(doc.data().logo)
                } else {
                    setLogo('')
                }
            })
    }, [logochange, logo])

    useEffect(() => {
        firebase.db.collection('backupsettings').doc('settings').get()
            .then((doc) => {
                if (doc.exists) {
                    setBgimage(doc.data().bgimage)
                } else {
                    setBgimage('')
                }
            })
    }, [bgimagechange, bgimage])

    const changeTitle = prop => event => {
        var value = event.target.value
        localStorage.setItem('apptitle', value)
        setApptitle(true)
        setinputChanged(false)
        setSwitchchange(true)
    }

    const handleChangeLanguage = name => event => {
        setState({
            ...state,
            [name]: event.target.value,
        })
        localStorage.setItem('language', event.target.value)
        i18n.changeLanguage(event.target.value)
        setinputChanged(false)
        setSwitchchange(true)
    }

    return (
        <main className={classes.main}>
            {isadmin === true ?
                <div>
                    <div>
                        <Prompt
                            when={inputChanged === false}
                            message={`${t('inputchanged.label')}`}
                        />
                    </div>

                    <Paper className={classes.paper} style={{ alignItems: 'center', textAlign: 'center', }}>
                        <Typography variant="h6" gutterBottom>
                            {t('settings.label')}
                        </Typography>
                    </Paper>

                    <Paper className={classes.paper} style={{ alignItems: 'center', textAlign: 'center', }}>
                        <Typography variant="body1" style={{ textAlign: 'center' }} gutterBottom>
                            <strong>{t('logo.label')}</strong>
                        </Typography>
                        <br />
                        {!logo ?
                            <Avatar className={classes.avatar}>
                                <BusinessIcon />
                            </Avatar>
                            :
                            <img src={logo} className={classes.logo} alt="Logo" />
                        }
                        <FormControl fullWidth style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            {!loading ?
                                <div></div>
                                :
                                <span style={{width: 100, marginLeft: 50}}><LoadingDots style={{width: '100%'}}/></span>
                            }
                            <Fragment>
                                <input
                                    accept="image/*"
                                    className={classes.input}
                                    id="icon-button-photo"
                                    onChange={handleImageUpload}
                                    type="file"
                                    style={{ display: "none" }}
                                />
                                <label htmlFor="icon-button-photo">
                                    {!logo ?
                                        <div>
                                            <Tooltip title={t('uploadlogo.label')} aria-label="Add">
                                                <IconButton color="secondary" component="span">
                                                    <PhotoCamera className={classes.input} />
                                                </IconButton>
                                            </Tooltip>
                                            <FormHelperText className={classes.formHelper}>{t('addlogo.label')}</FormHelperText>
                                        </div>
                                        :
                                        <div>
                                            <Tooltip title={t('uploadlogo.label')} aria-label="Add">
                                                <IconButton color="secondary" component="span">
                                                    <PhotoCamera className={classes.input} />
                                                </IconButton>
                                            </Tooltip>
                                            <FormHelperText className={classes.formHelper}>{t('changelogo.label')}</FormHelperText>
                                        </div>
                                    }
                                </label>
                            </Fragment>
                        </FormControl>
                    </Paper>

                    <Paper className={classes.paper} style={{ alignItems: 'center', textAlign: 'center', }}>
                        <Typography variant="body1" style={{ textAlign: 'center' }} gutterBottom>
                            <strong>{t('loginscreen.label')}</strong>
                        </Typography>
                        {!bgimage ?
                            <span></span>
                            :
                            <div>
                                <br />
                                <img src={bgimage} className={classes.bgimg} alt="Background" />
                            </div>
                        }
                        <FormControl fullWidth style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            {!bgloading ?
                                <div></div>
                                :
                                <span style={{width: 100, marginLeft: 50}}><LoadingDots style={{width: '100%'}}/></span>
                            }
                            <Fragment>
                                <input
                                    accept="image/*"
                                    className={classes.input}
                                    id="bgimage-button-photo"
                                    onChange={handleBGImageUpload}
                                    type="file"
                                    style={{ display: "none" }}
                                />
                                <label htmlFor="bgimage-button-photo">
                                    {!bgimage ?
                                        <div>
                                            <Tooltip title={t('uploadbgimage.label')} aria-label="Add">
                                                <IconButton color="secondary" component="span">
                                                    <PhotoCamera className={classes.input} />
                                                </IconButton>
                                            </Tooltip>
                                            <FormHelperText className={classes.formHelper}>{t('addbgimage.label')}</FormHelperText>
                                        </div>
                                        :
                                        <div>
                                            <Tooltip title={t('uploadbgimage.label')} aria-label="Add">
                                                <IconButton color="secondary" component="span">
                                                    <PhotoCamera className={classes.input} />
                                                </IconButton>
                                            </Tooltip>
                                            <FormHelperText className={classes.formHelper}>{t('changebgimage.label')}</FormHelperText>
                                        </div>
                                    }
                                </label>
                            </Fragment>
                        </FormControl>
                        {!bgimage ?
                            <span></span>
                            :
                            <div>
                                <Tooltip title={t('removebgbutton.label')} aria-label="Add">
                                    <IconButton edge="end" aria-label="Remove Background Image" style={{ marginLeft: -12 }} onClick={handleImageRemove}>
                                        <RemoveCircleIcon className={classes.input} style={{ color: red[500] }} />
                                    </IconButton>
                                </Tooltip>
                                <FormHelperText className={classes.formHelper}>{t('removebgimage.label')}</FormHelperText>
                            </div>
                        }
                    </Paper>

                    <Paper className={classes.paperList} style={{ alignItems: 'center', }}>
                        <Typography variant="body1" style={{ textAlign: 'center' }} gutterBottom>
                            <strong>{t('documenttitle.label')}</strong>
                        </Typography>
                        <br />
                        <Typography variant="h6" style={{ textAlign: 'center' }} gutterBottom>
                            {apptitle}
                        </Typography>
                        <FormControl className={classes.formControl}>
                            <TextField
                                label={t('taskentertitle.label')}
                                placeholder={t('entertitle.label')}
                                fullWidth={true}
                                margin='normal'
                                onChange={changeTitle()}
                                onSubmit={e => (e.target.reset())}
                                helperText={t('setdocumenttitle.label')}
                            />
                        </FormControl>
                    </Paper>

                    <Paper className={classes.paperList} style={{ alignItems: 'center', }}>
                        <Typography variant="body1" style={{ textAlign: 'center' }} gutterBottom>
                            <strong>{t('setdefaultlanguage.label')}</strong>
                        </Typography>
                        <br />
                        <FormControl variant="outlined" className={classes.formControl}>
                            <Select
                                native
                                value={state.lang}
                                onChange={handleChangeLanguage('lang')}
                                input={
                                    <OutlinedInput name="lang" margin='dense' />
                                }
                            >
                                <option value="en">English</option>
                                <option value="de">Deutsch</option>
                                <option value="it">Italiano</option>
                            </Select>
                        </FormControl>
                    </Paper>

                    <Paper className={classes.paperList}>
                        {switchchange === '' ?
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled
                                onClick={createSettings}
                                className={classes.submit}>
                                {t('savesettings.label')}
                            </Button>
                            :
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                onClick={createSettings}
                                className={classes.submit}>
                                {t('savesettings.label')}
                            </Button>
                        }
                    </Paper>
                </div>
                :
                <Paper className={classes.paper} style={{ textAlign: 'center', }}>
                    <Typography variant="button" display="block" gutterBottom>
                        <strong>{t('noprivileges.label')}</strong>
                    </Typography>
                </Paper>
            }
        </main>
    )

    async function handleImageUpload(event) {
        setLoading(true)
        const imageFile = event.target.files[0]
        var options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        }
        try {
            await createSettings()
            await firebase.changeLogo(firebase.auth.currentUser.uid)
            const compressedFile = await imageCompression(imageFile, options)
            await firebase.storage.ref(`backuplogo/${compressedFile.name}`).put(compressedFile)
                .then(() => {
                    firebase.storage.ref('backuplogo').child(compressedFile.name).getDownloadURL()
                        .then(url => {
                            dispatch({
                                type: 'changeLogo',
                                newTheme: { logosrc: url }
                            })
                            firebase.db.collection('backupsettings').doc('settings').update({
                                logo: url
                            }).then(() => {
                                toast.success(`${t('profilepicturesuccess.label')}`)
                                setTimeout(() => {
                                    setLoading(false)
                                }, 800)
                            }).then((url) => {
                                setLogo(url)
                                setLogochange(true)
                            })
                                .catch((error) => {
                                    return
                                })
                        })
                })
            toast.info(`${t('imageupload.label')}`)
        } catch (error) {
            return
        }
    }

    async function handleBGImageUpload(event) {
        setBgloading(true)
        const imageFile = event.target.files[0]
        var options = {
            maxSizeMB: 0.8,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        }
        try {
            await createSettings()
            await firebase.changeBGImage(firebase.auth.currentUser.uid)
            const compressedFile = await imageCompression(imageFile, options)
            await firebase.storage.ref(`backupbackground/${compressedFile.name}`).put(compressedFile)
                .then(() => {
                    firebase.storage.ref('backupbackground').child(compressedFile.name).getDownloadURL()
                        .then(url => {
                            dispatch({
                                type: 'changeBgimage',
                                newTheme: { bgimagesrc: url }
                            })
                            firebase.db.collection('backupsettings').doc('settings').update({
                                bgimage: url
                            }).then(() => {
                                toast.success(`${t('profilepicturesuccess.label')}`)
                                setTimeout(() => {
                                    setBgloading(false)
                                }, 800)
                            }).then((url) => {
                                setBgimage(url)
                                setBgimagechange(true)
                            })
                                .catch((error) => {
                                    return
                                })
                        })
                })
            toast.info(`${t('imageupload.label')}`)
        } catch (error) {
            return
        }
    }

    function handleImageRemove() {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className={classes.customAlert}>
                        <Typography variant="h5" display="block" gutterBottom>
                            <strong>{t('sure.label')}?</strong>
                        </Typography>
                        <Typography variant="body2" display="block" gutterBottom>
                            {t('removebgimage.label')}?
						</Typography>
                        <Button
                            type="submit"
                            variant="outlined"
                            color="primary"
                            onClick={async () => {
                                try {
                                    await firebase.changeBGImage(firebase.auth.currentUser.uid)
                                    await setBgimage('')
                                    await firebase.db.collection('backupsettings').doc('settings').update({
                                        bgimage: ''
                                    })
                                    onClose()
                                } catch (error) {
                                    toast.error(`${t('messageerrorbgimage.label')}`)
                                }
                            }}
                            className={classes.alertButton}>
                            {t('yes.label')}
                        </Button>
                        <Button
                            type="submit"
                            variant="outlined"
                            onClick={() => {
                                onClose()
                            }}
                            color="primary"
                            className={classes.alertButton}>
                            {t('no.label')}
                        </Button>
                    </div>
                )
            }
        })
    }

    async function createSettings(e) {
        const language = localStorage.getItem('language')
        const apptitle = localStorage.getItem('apptitle')
        try {
            await firebase.addSettings(
                language,
                apptitle,
                logo,
                bgimage
            )
            await setinputChanged(true)
            await setSwitchchange('')
            await toast.success(t('settingssuccess.label'))
            setTitle()
        }
        catch (error) {
            toast.error(t('saveerror.label'))
        }
    }

    function setTitle() {
        if (apptitle === true) {
            window.location.reload()
        } else {
            return
        }
    }

}

export default withStyles(styles)(Settings)